import React, { useState } from 'react';

import { Grid } from '@metarouter-private/mr-mui';

import EventSearchBar from './EventSearchBar';
import EventSearchTypeSelect from './EventSearchTypeSelect';

import { FILTER_KEYS } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

export default function EventSearch() {
  const [searchType, setSearchType] = useState(FILTER_KEYS.EVENT_NAMES);

  return (
    <Grid container direction="row" alignItems="center" spacing={0.5}>
      <Grid item xs={2}>
        <EventSearchTypeSelect searchType={searchType} onChange={setSearchType} />
      </Grid>

      <Grid item xs={10}>
        <EventSearchBar searchType={searchType} />
      </Grid>
    </Grid>
  );
}
